import { render, staticRenderFns } from "./StockSlipPayment.vue?vue&type=template&id=3a97af42"
import script from "./StockSlipPayment.vue?vue&type=script&lang=js"
export * from "./StockSlipPayment.vue?vue&type=script&lang=js"
import style0 from "./StockSlipPayment.vue?vue&type=style&index=0&id=3a97af42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports